import { ReactNode } from 'react';
import {
  Dialog, IconButton, useMediaQuery, SxProps, Theme,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { Breakpoint, useTheme } from '@mui/material/styles';

interface Props {
  open: boolean;
  onCancel: () => void;
  children: ReactNode;
  maxWidth?: false | Breakpoint;
  sx?: SxProps<Theme>;
}

export const Modal = ({
  open, onCancel, maxWidth, children, sx,
}: Props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth={maxWidth || 'lg'}
      fullWidth
      fullScreen={isMobile}
      sx={sx}
    >
      <div className="p-6">
        <div className="absolute right-2 top-2">
          <IconButton onClick={onCancel}>
            <Close />
          </IconButton>
        </div>
        {children}
      </div>
    </Dialog>
  );
};
